// crewbit-admin/src/components/schedule/MonthGrid.tsx
//
// Schedule Module Phase C C3 — month grid (admin pair). Body parallel to
// mobile MonthGrid.tsx modulo runtime; admin uses CSS Grid for the 7-col layout
// + supports HTML5 drag-drop for cross-cell reschedule.
//
// Spec: docs/references/schedule/SCHEDULE_MODULE_SPEC_v1.md §4.3 + §4.5 + §4.8.

import { palette, admin } from '../../styles/tokens';
import type { ScheduleEntry } from '../../types/schedule';
import type { LeaseBoundaryKind } from '../../hooks/useLeaseBoundariesByMonth';
import { MonthCell } from './MonthCell';

const DOW_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export interface MonthGridProps {
  days: { iso: string; isCurrentMonth: boolean }[];
  entriesByDate: Record<string, ScheduleEntry[]>;
  leaseBoundariesByDate?: Map<string, LeaseBoundaryKind>;
  showRecurringBadges?: boolean;
  onCellTap: (date: string) => void;
  onCellDrop?: (date: string, droppedEntryId: string) => void;
}

function todayIso(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function MonthGrid({
  days,
  entriesByDate,
  leaseBoundariesByDate,
  showRecurringBadges,
  onCellTap,
  onCellDrop,
}: MonthGridProps) {
  const today = todayIso();

  return (
    <div style={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      padding: 8,
      backgroundColor: admin.bg,
    }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', backgroundColor: admin.bg, padding: '8px 0' }}>
        {DOW_LABELS.map((d) => (
          <div key={d} style={{
            textAlign: 'center',
            fontSize: 11, fontWeight: 600, color: palette.g500,
            textTransform: 'uppercase', letterSpacing: 0.4,
          }}>
            {d}
          </div>
        ))}
      </div>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(7, 1fr)',
        gap: 0,
        flex: 1,
      }}>
        {days.map((day) => (
          <MonthCell
            key={day.iso}
            date={day.iso}
            entries={entriesByDate[day.iso] ?? []}
            isCurrentMonth={day.isCurrentMonth}
            isToday={day.iso === today}
            density="desktop"
            onTap={onCellTap}
            onCellDrop={onCellDrop}
            showRecurringBadges={showRecurringBadges}
            leaseBoundary={leaseBoundariesByDate?.get(day.iso)}
          />
        ))}
      </div>
    </div>
  );
}
